import styled from 'styled-components'

import { helpers } from 'styles'

export const AlertBox = styled.div`
	border-radius: 6px;
	background-color: ${helpers.color.errorContrast};
	color: ${helpers.color.text};
	padding: 12px 16px;
	font-size: 15px;
	position: absolute;
	bottom: 16px;
	right: 16px;
	z-index: 100;

	@media only screen and (max-width: 750px) {
		top: 60px;
		left: 0;
		right: 0;
		font-size: 13px;
		text-align: center;
		border-radius: 0;
		bottom: unset;
	}
`
